<template>
  <div class="auth-sidebar-registration">
    <section class="register component">
      <div class="register-form-wrapper">
        <div class="register-form-logo icon-fan-logo-black">
          <span class="sr-only">{{ tc("auth.fansMoTitle") }}</span>
        </div>
        <registration-form source="MoWeb:BookingEngine:TeaserSignup">
          <form
            id="register-form"
            slot-scope="{
              serverErrorMsg,
              isValid,
              isLoading,
              grecaptchaReadyCallback,
              grecaptchaReady,
              grecaptchaCallback,
              grecaptchaExecute,
              grecaptchaToken
            }"
            class="form register-form"
            action="/api/v1/profile/register"
          >
            <fieldset>
              <legend>{{ registrationComponentData.Title }}</legend>
              <div class="flex-grid-1-col gutter-lg">
                <div class="input dropdown user-titles">
                  <select
                    id="usertitle"
                    class="req"
                    name="title"
                    data-val="true"
                    :data-val-required="
                      getValidationForField('required', 'title')
                    "
                    data-field-type="DropdownList"
                  >
                    <option value="" />
                    <option
                      v-for="title in userTitles"
                      :key="title.value"
                      :value="title.value"
                    >
                      {{ title.label }}
                    </option>
                  </select>
                  <label
                    for="title"
                    class="floating req"
                  >
                    {{ tc("formFields.title") }}
                  </label>
                  <span
                    data-valmsg-for="title"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
                <div class="input">
                  <input
                    id="firstname"
                    type="text"
                    name="firstname"
                    maxlength="255"
                    value=""
                    class="req"
                    data-val="true"
                    data-rule-minlength="1"
                    data-rule-maxlength="50"
                    :data-msg-minlength="getValidationForField('minChars', '1')"
                    :data-msg-maxlength="getValidationForField('maxChars', '50')"
                    :data-val-required="getValidationForField('required', 'firstName')"
                    :data-val-no-special-chars="tc('validations.noSpecialChars')"
                    data-field-type="SingleLineText"
                  >

                  <label
                    for="firstname"
                    class="req floating"
                  >
                    {{ tc("formFields.firstName") }}
                  </label>

                  <span
                    data-valmsg-for="firstname"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
                <div class="input">
                  <input
                    id="lastname"
                    type="text"
                    name="lastname"
                    maxlength="255"
                    value=""
                    class="req"
                    data-val="true"
                    data-rule-minlength="1"
                    data-rule-maxlength="65"
                    :data-msg-minlength="getValidationForField('minChars', '1')"
                    :data-msg-maxlength="getValidationForField('maxChars', '65')"
                    :data-val-required="getValidationForField('required', 'lastName')"
                    :data-val-no-special-chars="tc('validations.noSpecialChars')"
                    data-field-type="SingleLineText"
                  >

                  <label
                    for="lastname"
                    class="req floating"
                  >
                    {{ tc("formFields.lastName") }}
                  </label>

                  <span
                    data-valmsg-for="lastname"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
              </div>
              <div class="flex-grid-1-col gutter-lg">
                <div class="input">
                  <input
                    id="email"
                    type="email"
                    name="email"
                    value=""
                    class="req"
                    data-val="true"
                    maxlength="255"
                    data-val-external="email"
                    data-rule-minlength="6"
                    data-rule-maxlength="255"
                    :data-msg-minlength="getValidationForField('minChars', '6')"
                    :data-msg-maxlength="getValidationForField('maxChars', '255')"
                    :data-external-msg="getValidationForField('externalEmail')"
                    :data-val-required="getValidationForField('required', 'email')"
                    :data-val-regex="tc('validations.email')"
                    data-val-regex-pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$"
                    data-field-type="Email"
                  >

                  <label
                    for="email"
                    class="req floating"
                  >
                    {{ tc("formFields.email") }}
                  </label>

                  <span
                    data-valmsg-for="email"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
              </div>
              <div class="flex-grid-1-col gutter-lg">
                <div class="input">
                  <input
                    id="email_confirmation"
                    type="email"
                    name="email_confirmation"
                    value=""
                    class="req"
                    maxlength="255"
                    data-val="true"
                    data-val-external="email"
                    data-rule-minlength="6"
                    data-rule-maxlength="255"
                    :data-msg-minlength="getValidationForField('minChars', '6')"
                    :data-msg-maxlength="getValidationForField('maxChars', '255')"
                    :data-external-msg="getValidationForField('externalEmail')"
                    :data-val-required="getValidationForField('required', 'emailConfirmation')"
                    data-val-equals-to="#email"
                    :data-val-equals="
                      getValidationForField(
                        'confirmationField',
                        'emailConfirmation'
                      )
                    "
                    :data-val-regex="tc('validations.email')"
                    data-val-regex-pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,17}$"
                    data-field-type="Email"
                  >

                  <label
                    for="email_confirmation"
                    class="req floating"
                  >
                    {{ tc("formFields.emailConfirmation") }}
                  </label>

                  <span
                    data-valmsg-for="email_confirmation"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
              </div>
              <div class="flex-grid-2-col gutter-lg">
                <div class="input dropdown country-code">
                  <select
                    id="phoneCountryCode"
                    name="phoneCountryCode"
                    value=""
                    class="req"
                    data-val="true"
                    data-val-external="phone"
                    :data-external-msg="getValidationForField('externalPhone')"
                    :data-val-required="
                      getValidationForField('required', 'country')
                    "
                    data-field-type="DropdownList"
                  >
                    <option value="" />
                    <option
                      v-for="country in countries"
                      :key="country.Name + 'Phone'"
                      :value="country.CallingCode"
                    >
                      {{ `${country.Name} (+${country.CallingCode})` }}
                    </option>
                  </select>

                  <label
                    for="phoneCountryCode"
                    class="req floating"
                  >
                    {{ tc("formFields.country") }}
                  </label>

                  <span
                    data-valmsg-for="phoneCountryCode"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
                <div class="input phone">
                  <input
                    id="phoneNumber"
                    type="tel"
                    name="phoneNumber"
                    value=""
                    class="req"
                    data-val="true"
                    data-val-external="phone"
                    :data-external-msg="getValidationForField('externalPhone')"
                    :data-val-required="
                      getValidationForField('required', 'phoneNumber')
                    "
                    data-val-regex-pattern="^[\d\+\-\(\)\s]*$"
                    :data-val-regex="tc('validations.phone')"
                    data-rule-minlength="5"
                    data-rule-maxlength="17"
                    :data-msg-minlength="getValidationForField('minChars', '5')"
                    :data-msg-maxlength="
                      getValidationForField('maxChars', '17')
                    "
                    :data-val-phone-number="tc('validations.phone')"
                    data-field-type="NativePhone"
                  >

                  <label
                    for="phoneNumber"
                    class="req floating"
                  >
                    {{ tc("formFields.phoneNumber") }}
                  </label>

                  <span
                    data-valmsg-for="phoneNumber"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
              </div>
              <div class="flex-grid-1-col gutter-lg">
                <div class="input">
                  <input
                    id="password"
                    type="password"
                    name="password"
                    value=""
                    class="req"
                    data-val="true"
                    :data-val-required="
                      getValidationForField('required', 'password')
                    "
                    data-rule-minlength="8"
                    :data-msg-minlength="
                      getValidationForField('passwordLength', '8')
                    "
                    :data-val-hasnumber="tc('validations.passwordNumber')"
                    :data-val-haslowercase="tc('validations.passwordLowerCase')"
                    :data-val-hasuppercase="tc('validations.passwordUpperCase')"
                    :data-val-special-chars="tc('validations.specialChars')"
                    :data-val-has-no-password-as-input="
                      tc('validations.hasNoPasswordAsInput')
                    "
                    :data-val-consecutive-characters="
                      tc('validations.consecutiveCharacters')
                    "
                    data-password-validation="true"
                    data-field-type="PasswordField"
                  >

                  <label
                    for="password"
                    class="req floating"
                  >
                    {{ tc("formFields.password") }}
                  </label>
                  <em
                    :aria-label="tc('formFields.passwordVisiblityToggle')"
                    tabindex="0"
                    class="fa fa-eye password-toggle"
                    type="button"
                    role="switch"
                    aria-checked="false"
                    data-for="password"
                  />

                  <div class="password-rules">
                    <small v-html="tc('formFields.passwordRules')" />
                  </div>

                  <span
                    data-valmsg-for="password"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
                <div class="input">
                  <input
                    id="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    value=""
                    class="req"
                    data-val="true"
                    data-val-equals-to="#password"
                    :data-val-required="
                      getValidationForField('required', 'passwordConfirmation')
                    "
                    :data-val-equals="
                      getValidationForField(
                        'confirmationField',
                        'passwordConfirmation'
                      )
                    "
                    data-field-type="PasswordField"
                  >

                  <label
                    for="password_confirmation"
                    class="req floating"
                  >
                    {{ tc("formFields.passwordConfirmation") }}
                  </label>
                  <em
                    :aria-label="tc('formFields.passwordVisiblityToggle')"
                    tabindex="0"
                    class="fa fa-eye password-toggle"
                    type="button"
                    role="switch"
                    aria-checked="false"
                    data-for="password_confirmation"
                  />

                  <span
                    data-valmsg-for="password_confirmation"
                    data-valmsg-replace="true"
                    class="field-validation-valid"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend class="sr-only">
                Agreements
              </legend>
              <div class="flex-grid-1-col gutter-lg">
                <div class="text-block no-label">
                  <h3 class="agreements-title">
                    {{ registrationComponentData.StayConnectedTitle }}
                  </h3>
                  <div
                    class="agreements-description"
                    v-html="registrationComponentData.StayConnectedDescription"
                  />
                </div>
              </div>
              <div class="flex-grid-1-col gutter-lg">
                <ul class="">
                  <template v-if="lang.toLowerCase() === 'zh-cn'">
                    <li>
                      <label>
                        <input
                          id="policy_use"
                          data-val="true"
                          :data-val-isChecked="tc('validations.ischecked')"
                          name="policy_use"
                          type="checkbox"
                        >
                        MOHG 将根据其隐私政策处理您的个人数据。您同意该类使用。*
                      </label>
                      <span
                        data-valmsg-for="policy_use"
                        data-valmsg-replace="true"
                        class="field-validation-valid"
                      />
                    </li>
                    <li>
                      <label>
                        <input
                          id="policy_share"
                          data-val="true"
                          :data-val-isChecked="tc('validations.ischecked')"
                          name="policy_share"
                          type="checkbox"
                        >
                        MOHG
                        将根据其隐私政策将您的个人数据传输至第三方。您同意该类共享。*
                      </label>
                      <span
                        data-valmsg-for="policy_share"
                        data-valmsg-replace="true"
                        class="field-validation-valid"
                      />
                    </li>
                    <li>
                      <label>
                        <input
                          id="policy_outside"
                          data-val="true"
                          :data-val-isChecked="tc('validations.ischecked')"
                          name="policy_outside"
                          type="checkbox"
                        >
                        MOHG
                        将根据其隐私政策将您的个人数据传输至中华人民共和国境外的第三方。您同意此类共享。*
                      </label>
                      <span
                        data-valmsg-for="policy_outside"
                        data-valmsg-replace="true"
                        class="field-validation-valid"
                      />
                    </li>
                  </template>
                  <li>
                    <label>
                      <input
                        id="communications_agree"
                        name="communications_agree"
                        type="checkbox"
                        :checked="defaultCheckedForRegistration"
                      >
                      {{ registrationComponentData.AgreeCommunications }}
                    </label>
                    <span
                      data-valmsg-for="communications_agree"
                      data-valmsg-replace="true"
                      class="field-validation-valid"
                    />
                  </li>
                  <li>
                    <label>
                      <input
                        id="sensitive_data_agree"
                        name="sensitive_data_agree"
                        type="checkbox"
                        :checked="defaultCheckedForRegistration"
                      >
                      {{ registrationComponentData.AgreeSensitiveData }}
                    </label>
                    <span
                      data-valmsg-for="sensitive_data_agree"
                      data-valmsg-replace="true"
                      class="field-validation-valid"
                    />
                  </li>
                </ul>
              </div>
              <div class="flex-grid-1-col gutter-lg">
                <div class="agreements-wrapper text-block no-label">
                  <h3 class="agreements-title">
                    {{ registrationComponentData.TermsTitle }}
                  </h3>
                  <div class="collapsible component">
                    <ul
                      class="collapsible-wrapper container"
                      aria-label="Collapsible Control Group Buttons"
                    >
                      <accordion-tab>
                        <template slot-scope="{ toggleTab, expanded }">
                          <li class="collapsible-item">
                            <div
                              id="agreements-collapsible"
                              class="collapsible-item-content"
                              :class="expanded ? 'expanded' : ''"
                              :aria-hidden="expanded ? 'false' : 'true'"
                            >
                              <div
                                tabindex="0"
                                class="collapsible-item-content-wrapper"
                                @focus="toggleTab"
                                v-html="registrationComponentData.Terms"
                              />
                            </div>
                            <button
                              id="agreements-collapsible-control"
                              class="collapsible-item-label"
                              :class="expanded ? 'expanded' : ''"
                              aria-controls="content-1"
                              :aria-expanded="expanded ? 'true' : 'false'"
                              @click.prevent="toggleTab"
                              @enter="toggleTab"
                              @keydown.space.prevent="toggleTab"
                            />
                          </li>
                        </template>
                      </accordion-tab>
                    </ul>
                  </div>
                </div>
              </div>
            </fieldset>
            <template v-if="registrationComponentData.ReCaptchaEnabled">
              <grecaptcha
                ref="grecaptchaLogin"
                :sitekey="registrationComponentData.ReCaptchaSiteKey"
                :element-id="'g-recaptcha'"
                @grecaptcha-callback="grecaptchaCallback"
                @grecaptcha-ready="grecaptchaReadyCallback"
              />
              <input
                v-model="grecaptchaToken"
                type="hidden"
                name="grecaptchaToken"
              >
              <input
                type="hidden"
                name="reCaptchaEnabled"
                :value="registrationComponentData.ReCaptchaEnabled"
              >
            </template>
            <div class="form-submit">
              <button
                v-if="registrationComponentData.ReCaptchaEnabled"
                class="button register-cta"
                :class="[{ loading: isLoading }]"
                :disabled="!isValid || !grecaptchaReady"
                @click.prevent="grecaptchaExecute"
              >
                {{ tc("auth.signUpCta") }}
              </button>
              <button
                v-else
                class="button register-cta"
                :class="[{ loading: isLoading }]"
                :disabled="!isValid"
              >
                {{ tc("auth.signUpCta") }}
              </button>
              <div
                class="sr-only"
                role="status"
              >
                {{ isLoading ? tc('accessibility.loadingButtonStatus') : '' }}
              </div>
            </div>

            <div
              class="error-msg"
              :class="[{ show: !!serverErrorMsg }]"
              v-html="serverErrorMsg"
            />
          </form>
        </registration-form>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Grecaptcha from '@components/02.account/grecaptcha/grecaptcha.vue'
  import Tracking from '@mixins/tracking'

  export default {
    name: 'SidebarRegistration',
    components: {
      Grecaptcha
    },
    mixins: [Tracking],
    inject: {
      defaultCheckedForRegistration: {
        default: false
      },
      userTitles: {
        default: []
      },
      skipBookingTracking: {
        default: false
      }
    },
    computed: {
      ...mapState('auth', ['registrationComponentData']),
      ...mapState('global', ['lang', 'countries']),
      ...mapState('modifyReservation', ['isBookingEditMode']),
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('booking', ['getQuery', 'bookingFlow']),
    },
    mounted() {
      if (!this.skipBookingTracking) {
        this.$track(this.getTrackingData('booking', this.getQuery, { event: 'step4' }))
        this.$track(this.getTrackingData(this.isBookingEditMode ? 'modifyReservation' : 'booking', this.getQuery, {
          event: 'bookingStateChange',
          bookingEngine: {
            bookingStepNumber: this.isBookingEditMode ? '2.2.2' : '3.2.2',
            bookingStepName: 'Fans of MO Signup Flyout',
            bookingEngineVersion: this.isBookingEditMode ? '2' : '1',
            bookingFlow: this.bookingFlow()
          }
        }))
      }
    },
    methods: {
      getValidationForField(validation, field = '') {
        return this.tc(`validations.${validation}`).replace(
          '{0}',
          this.tc(`formFields.${field}`)
        )
      },
    },
  }
</script>
